import { useEffect, useRef, useState } from 'react';
import './style.css';
import { Icon } from '@chatui/core';
import { AudioPlayingLoader } from '../Loader';
import { MessageId } from '@chatui/core/lib/components/Message';

interface AudioMessageProps {
  messageId: MessageId;
  src: string;
  audioPlayingId: MessageId;
  onPlay: () => void;
}
const AudioMessage = (props: AudioMessageProps) => {
  const { messageId, src = '', audioPlayingId, onPlay } = props;
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  useEffect(() => {
    if (audioPlayingId !== messageId && audioRef.current && isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  }, [audioPlayingId, audioRef, isPlaying, messageId]);

  return (
    <div className="audio-message">
      <audio
        src={src}
        ref={audioRef}
        onPlay={() => setIsPlaying(true)}
        onPause={() => {
          setIsPlaying(false);
        }}
        onEnded={() => {
          setIsPlaying(false);
        }}
      />
      {isPlaying && <AudioPlayingLoader />}
      {isPlaying ? (
        <button
          className="IconBtn"
          onClick={() => {
            audioRef.current?.pause();
          }}
        >
          <span className="stop-icon" />
        </button>
      ) : (
        <Icon
          type="bullhorn"
          onClick={() => {
            if (audioRef.current) {
              audioRef.current.currentTime = 0;
              audioRef.current.play();
              onPlay();
            }
          }}
        />
      )}
    </div>
  );
};

export default AudioMessage;
